// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { ApiParameter, get, ServiceResult } from "@insite/client-framework/Services/ApiService";
import { ProductCollectionModel } from "@insite/client-framework/Types/ApiModels";

const apiUrl = "/api/guest/shipment/shipViaRates";

export interface GetShipViaRatesParameter {
    shipViaIds: string[];
}

export interface ShipViaRateResult {
    shipViaId: string;
    shippingRate: string;
}

export async function getShipViaRates(parameter: GetShipViaRatesParameter): Promise<ShipViaRateResult[]> {
    const result = await get<ShipViaRateResult[]>(`${apiUrl}/?shipViaIds=${parameter.shipViaIds.join("&shipViaIds=")}`);
    return result;
}
